import React from 'react'
import { draftIsEqualPublished } from '../utils/draftIsEqualPublished'
import { SetQuizSettings } from './SetQuizSettings'
import { SetDuration } from './SetDuration'
import { TopicCoverImage } from './TopicCoverImage'
import SetTopicVersionType from './SetTopicVersionType'
import { SetVideoAssessmentPassMark } from './SetVideoAssessmentPassMark'
import { SetVideoAssessmentTitle } from './SetVideoAssessmentTitle'
import { SetVideoAssessmentDescription } from './SetVideoAssessmentDescription'
import { videoAssessmentTopicVersionTypesForFE } from '../../StudentTopicDetail'
import { IResourceSettingsDrawerProps } from './ResourceDrawer'
import { Box, DrawerItem } from 'front-end/src/components'
import { brandColors } from 'shared/basicPalette'
import { Trans } from '@lingui/macro'

export const ResourceSettingsDrawerContent = ({
  topic
}: {
  topic: IResourceSettingsDrawerProps['topic']
}) => {
  const { draftVersion } = topic
  const isVideoAssessment =
    draftVersion?.topic_type &&
    videoAssessmentTopicVersionTypesForFE.includes(draftVersion?.topic_type)

  const unpublishedChanges =
    !!topic.draftVersion &&
    !draftIsEqualPublished(
      topic.currentTopicVersionAsEditor,
      topic.draftVersion
    )

  return (
    <>
      {unpublishedChanges && (
        <DrawerItem>
          <Box p="12px" bgColor={brandColors.yellow['50']} borderRadius="4px">
            <Trans>
              These changes will only be visible to users when a new version of
              this resource is published.
            </Trans>
          </Box>
        </DrawerItem>
      )}
      <SetQuizSettings key={`SetQuizSettings-${topic.id}`} />
      <SetDuration />
      <TopicCoverImage />
      <SetTopicVersionType />
      {isVideoAssessment && (
        <>
          <SetVideoAssessmentPassMark />
          <SetVideoAssessmentTitle />
          <SetVideoAssessmentDescription />
        </>
      )}
    </>
  )
}
